import { Link } from "react-router-dom";
import { collections } from "@/lib/filmData";

export default function CollectionShowcase() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
      {collections.map((item) => (
        <Link
          key={item.id}
          to={`/search?q=${encodeURIComponent(item.query)}`}
          className="group relative flex h-[260px] flex-col justify-end overflow-hidden rounded-lg md:h-[300px]"
        >
          <img
            src={item.image}
            alt={`${item.title} 专题封面`}
            title={`${item.title} - 新金瓶梅热门推荐专题`}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/55 to-transparent"></div>
          <div className="relative p-5">
            <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-primary-950">
              <i className="ri-bookmark-3-line" aria-hidden="true"></i>
              精选专题
            </span>
            <h3 className="mt-3 font-heading text-lg font-extrabold text-background-50">
              {item.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm text-background-200">{item.description}</p>
            <span className="mt-3 flex items-center gap-1 text-sm font-medium text-accent-400">
              查看专题片单
              <i
                className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                aria-hidden="true"
              ></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}